/**
 * 分店選單／列表：名稱以 [TEST] 開頭者排到最後（其餘維持相對順序）。
 */

const TEST_PREFIX = /^\[TEST\]/i;

export function getBranchDisplayName(branch) {
  if (branch == null) return "";
  if (typeof branch === "string") return branch;
  return String(
    branch.branch_name ??
      branch.branchName ??
      branch.name ??
      branch.label ??
      ""
  );
}

export function isTestBranchName(name) {
  return TEST_PREFIX.test(String(name || "").trim());
}

export function isTestBranch(branch) {
  return isTestBranchName(getBranchDisplayName(branch));
}

/**
 * @template T
 * @param {T[]} branches
 * @returns {T[]}
 */
export function sortBranchesPutTestLast(branches) {
  if (!Array.isArray(branches) || branches.length < 2) {
    return Array.isArray(branches) ? branches : [];
  }
  const normal = [];
  const test = [];
  for (const branch of branches) {
    (isTestBranch(branch) ? test : normal).push(branch);
  }
  return normal.concat(test);
}
